module.exports = __webpack_public_path__ + "static/media/Plants.d76edc22.jpg";